import React, { useEffect } from 'react';
import Slider from 'react-slick';
import bannerDesktop from "../assets/images/banner_desktop_final_002-01.webp";
import bannerDesktop2 from "../assets/images/Banner_desktop_final.webp";
import bannerDesktop3 from "../assets/images/banner3_desktop_final_001-01.webp";
import bannerMobile from "../assets/images/Banner_phone_002-01.webp";
import bannerMobile1 from "../assets/images/banner_phone_final.webp";
import bannerMobile2 from "../assets/images/Banner3_phone_final_001-01.webp";
import "../styles/Banner.css";
import { useLocation } from 'react-router-dom';

const BannerSlider = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollToId) {
      const el = document.getElementById(location.state.scrollToId);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 1700, // 2 seconds interval
    fade: false,
    cssEase: 'ease-in-out',
    arrows: false,
    pauseOnHover: false, // Keeps autoplay going on hover
    pauseOnFocus: false  // Keeps autoplay going when focused
  };

  return (
    <section className="banner__slider" id='homeBannerHaro'>
      <div className="slider-banner">
        <Slider {...settings}>
          <div className="slides">
            <div className="slide__img">
              <picture>
                <source media="(max-width: 768px)" srcSet={bannerMobile} />
                <img
                  src={bannerDesktop}
                  alt=""
                  className="full-image animated"
                  data-animation-in="zoomInImage"
                />
              </picture>
            </div>
          </div>
          <div className="slides">
            <div className="slide__img">
              <picture>
                <source media="(max-width: 768px)" srcSet={bannerMobile1} />
                <img
                  src={bannerDesktop2}
                  alt=""
                  className="full-image animated"
                  data-animation-in="zoomOutImage"
                />
              </picture>
            </div>
          </div>
          <div className="slides">
            <div className="slide__img">
              <picture>
                <source media="(max-width: 768px)" srcSet={bannerMobile2} />
                <img
                  src={bannerDesktop3}
                  alt=""
                  className="full-image animated"
                  data-animation-in="zoomInImage"
                />
              </picture>
            </div>
          </div>
        </Slider>
      </div>
    </section>
  );
};

export default BannerSlider;